/* Keep the visible collection count aligned with grouped style cards after facet updates. */
(() => {
  const syncGroupedCounts = () => {
    document.querySelectorAll('[data-grouped-collection]').forEach((section) => {
      const grid = section.querySelector('#product-grid');
      if (!grid) return;
      const count = String(grid.querySelectorAll('product-card').length);
      section.querySelectorAll('[data-facets-results-count]').forEach((label) => {
        if (label.textContent.trim() !== count) label.textContent = count;
      });
    });
  };
  const start = () => {
    syncGroupedCounts();
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        syncGroupedCounts();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
